import "@/styles/components/site-header.css";
import { animate, stagger } from "motion";
import { fireEvent } from "@/scripts/common/util";

const siteHeader = document.querySelector(".site-header");
const scrollPixel = document.querySelector(".scroll-pixel");
const siteMenu = document.getElementById("site-menu");
const mobileMenu = siteMenu?.querySelector('[data-menu="mobile"]');
const desktopMenu = siteMenu?.querySelector('[data-menu="desktop"]');

const getClipPathIn = () => {
  if (window.matchMedia("(min-width: 768px)").matches) {
    return { clipPath: ["inset(0 0 100% 100%)", "inset(0 0 0% 0%)"] };
  }

  return { clipPath: ["inset(0 0 0 100%)", "inset(0 0 0% 0%)"] };
};

const getClipPathOut = () => {
  if (window.matchMedia("(min-width: 768px)").matches) {
    return { clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 100%)"] };
  }

  return { clipPath: ["inset(0 0 0 0)", "inset(0 0 0% 100%)"] };
};

export default {
  init: () => {
    if (!siteHeader) {
      return;
    }

    if (siteHeader && scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }

    const siteMenuScreen = siteMenu?.querySelector(".site-menu-screen");

    document.documentElement.addEventListener("sitemenu:open", async () => {
      document.documentElement.classList.add("overflow-hidden");

      await animate(siteMenuScreen, getClipPathIn(), { duration: 0.3, easing: "ease-out" }).finished;

      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      const activeMenu = isDesktop ? desktopMenu : mobileMenu;

      animate(
        activeMenu.querySelectorAll("[data-menu-item]"),
        { y: [15, 0], opacity: [0, 1] },
        { duration: 0.2, easing: "ease-out", delay: stagger(0.05) },
      );
    });

    document.documentElement.addEventListener("sitemenu:close", async () => {
      document.documentElement.classList.remove("overflow-hidden");

      const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
      const activeMenu = isDesktop ? desktopMenu : mobileMenu;

      await animate(
        activeMenu.querySelectorAll("[data-menu-item]"),
        { opacity: [1, 0] },
        { duration: 0.1, easing: "ease-out" },
      ).finished;

      animate(siteMenuScreen, getClipPathOut(), { duration: 0.3, easing: "ease-in" });

      fireEvent("slidetoggle:reset", mobileMenu.querySelectorAll('[data-slide-toggle][aria-expanded="true"]'));
    });

    desktopMenu?.querySelectorAll("[data-menu-item]").forEach((li) => {
      li.addEventListener("mouseenter", () => {
        const childUl = li.querySelector("ul");
        if (!childUl) return;
        const parentUl = li.closest(".site-menu-items");
        const parentRect = parentUl.getBoundingClientRect();
        const liRect = li.getBoundingClientRect();
        const top = liRect.top - parentRect.top + liRect.height / 2;
        childUl.style.setProperty("--caret-top", `${top}px`);
      });
    });
  },
};
